/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { NbDateFnsDateModule } from "@nebular/date-fns";

import { environment } from "../environments/environment";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { NgxAuthModule } from "./@auth/auth.module";
import { AngularFireFunctionsModule, REGION } from "@angular/fire/functions";
import { AngularFireAnalyticsModule } from "@angular/fire/analytics";
import { NgxTimeSchedulerModule } from "ngx-time-scheduler";
import { QRCodeModule } from "angularx-qrcode";
import { vi } from "date-fns/locale";

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

//firebase-initialization
import firebase from "firebase/app";
import "firebase/app-check";
import { FullCalendarModule } from "@fullcalendar/angular";
if (environment.appCheck) {
  const app = firebase.initializeApp(environment.firebase);
  const appCheck = app.appCheck();
  appCheck.activate(environment.recaptcha);
  appCheck.setTokenAutoRefreshEnabled(true);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    QRCodeModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    // AngularFirestoreModule.enablePersistence(), //Use offline db => Bug on IOS
    AngularFireDatabaseModule,
    AngularFireFunctionsModule,
    AngularFireStorageModule,
    AngularFireMessagingModule,
    AngularFireAnalyticsModule,
    // ngx-translate and the loader module
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),

    NbDateFnsDateModule.forRoot({
      parseOptions: { locale: vi },
      formatOptions: { locale: vi },
    }),
    NbTimepickerModule.forRoot(),
    NgxTimeSchedulerModule,
    FullCalendarModule,

    CoreModule.forRoot(),
    ThemeModule.forRoot(),

    //Auth
    NgxAuthModule.forRoot(),
  ],
  providers: [{ provide: REGION, useValue: environment.regionLocation }],
  bootstrap: [AppComponent],
})
export class AppModule {}
